import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle } from "@phosphor-icons/react";
import * as Phosphor from "@phosphor-icons/react";
import SEO from "@/components/SEO";
import PageHero from "@/components/PageHero";
import CTASection from "@/components/CTASection";
import { SERVICES } from "@/lib/site";

const INCLUSIONS = [
  "Dedicated account manager + named site supervisor",
  "Bar-coded QA inspection logs available to client",
  "Color-coded microfiber program for cross-contamination control",
  "Green Seal & EPA Safer Choice chemistries by default",
  "Bonded, insured, and background-checked teammates",
  "Surge & emergency response within 4 hours, 24/7",
];

export default function Services() {
  return (
    <>
      <SEO title="Services" description="Full-spectrum commercial cleaning and facilities maintenance: medical, industrial, government, office, floor care, post-construction, and more." path="/services" />
      <PageHero
        eyebrow="Services"
        title="Comprehensive facilities maintenance."
        subtitle="Programs scaled from a single-shift office to multi-site, 24/7 medical and industrial campuses."
        image="https://images.pexels.com/photos/6197110/pexels-photo-6197110.jpeg"
        testId="services-hero"
      />

      <section className="es-section bg-white">
        <div className="es-container">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {SERVICES.map((s) => {
              const Icon = Phosphor[s.icon] || Phosphor.Wrench;
              return (
                <div key={s.slug} data-testid={`service-card-${s.slug}`} className="es-card p-7 flex flex-col">
                  <div className="w-12 h-12 bg-[var(--es-navy)] text-white rounded-sm flex items-center justify-center mb-5">
                    <Icon size={22} weight="duotone" />
                  </div>
                  <h3 className="text-lg font-bold text-[var(--es-navy)] leading-snug" style={{ fontFamily: "'IBM Plex Sans', sans-serif" }}>{s.title}</h3>
                  <p className="mt-3 text-sm text-[var(--es-text-muted)] leading-relaxed flex-1">{s.blurb}</p>
                  <Link to="/quote" className="mt-5 inline-flex items-center gap-1 text-sm font-semibold text-[var(--es-navy)] hover:gap-2 transition-all">
                    Get a quote <ArrowRight size={14} />
                  </Link>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="es-section bg-[var(--es-bg)]">
        <div className="es-container grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5">
            <div className="es-eyebrow">What's Included</div>
            <h2 className="es-h2 text-[var(--es-navy)] mt-3">A facility services contract that earns the next renewal.</h2>
            <p className="es-lede mt-4">Every Empire Serv account ships with the operational backbone you'd otherwise build in-house — included, not upsold.</p>
            <Link to="/quote" className="es-btn-accent mt-7 inline-flex" data-testid="services-quote-cta">Build my proposal <ArrowRight size={18} /></Link>
          </div>
          <ul className="lg:col-span-7 grid sm:grid-cols-2 gap-x-6 gap-y-4">
            {INCLUSIONS.map((inc) => (
              <li key={inc} className="flex items-start gap-3 text-sm">
                <CheckCircle size={20} weight="fill" className="text-[var(--es-accent)] flex-shrink-0 mt-0.5" />
                <span className="text-[var(--es-text)] leading-relaxed">{inc}</span>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <CTASection />
    </>
  );
}
